import * as React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { styled } from '@linaria/react';
import { DesktopBaseLayout } from 'components/Layouts/BaseDesktop';
import { PrivateRoute } from 'components/PrivateRoute';
import { motion } from 'framer-motion';
import { getAnonymousId, getLanguageCode } from 'modules/meta/selectors';
import { Card } from '@daedalus/atlas/Card';
import { useDeviceLayout } from '@daedalus/atlas/context/deviceLayout';
import { Footer } from '@daedalus/atlas/Footer';
import { PageWidthContainer as PageWidthContainerElement } from '@daedalus/atlas/helpers/PageWidthContainer';
import { ANIMATION_TYPES } from '@daedalus/atlas/Overlay/Overlay';
import transitions from '@daedalus/atlas/utils/framerTransitions';
import { getBrand } from '@daedalus/core/src/_web/brand/modules/selectors';
import { CookiePreferencesLink } from '@daedalus/shared/src/search/cookies/CookiePreferencesLink';
import { AccountSideMenu } from '@daedalus/shared/src/user/account/AccountSideMenu';
import { ACCOUNT_ROUTE, ALERTS_ROUTE, MEMBERSHIP_ROUTE, REFERRAL_ROUTE } from '../../constants';
import { AlertsRoute } from '../alerts';
import { AccountRoute } from './account';
import { MembershipRoute } from './membership';
import { PrivateReferralRoute } from './PrivateReferralRoute';
import { ReferralRoute } from './referral';
const PageGrid = /*#__PURE__*/styled('div')({
  name: "PageGrid",
  class: "p19mf5pk",
  propsAsIs: false
});
const PageContainerWrapper = /*#__PURE__*/styled('div')({
  name: "PageContainerWrapper",
  class: "p1p2d5hg",
  propsAsIs: false
});
const _exp8 = /*#__PURE__*/() => PageWidthContainerElement;
const PageWidthContainer = /*#__PURE__*/styled(_exp8())({
  name: "PageWidthContainer",
  class: "p8cgj0q",
  propsAsIs: true
});
interface ContentWrapperProps {
  isMobile: boolean;
  children: React.ReactNode;
}
const MobileContentWrapper = /*#__PURE__*/styled('div')({
  name: "MobileContentWrapper",
  class: "m1wfzdow",
  propsAsIs: false
});
const ContentWrapper = ({
  isMobile,
  children
}: ContentWrapperProps) => isMobile ? <MobileContentWrapper>
      <motion.div key="User" variants={transitions[ANIMATION_TYPES.SLIDE_RIGHT]} initial="exited" animate="entered" exit="exited" transition={{
    duration: 0.3
  }}>
        {children}
      </motion.div>
    </MobileContentWrapper> : <div>
      <Card borderRadius="md" shadow="action">
        {children}
      </Card>
    </div>;
const Layout = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const {
    isMobile
  } = useDeviceLayout();
  if (isMobile) return <>{children}</>;
  return <DesktopBaseLayout hasSearchForm={false}>{children}</DesktopBaseLayout>;
};
const UserView = () => {
  const {
    isMobile
  } = useDeviceLayout();
  const brand = useSelector(getBrand);
  const anonymousId = useSelector(getAnonymousId);
  const languageCode = useSelector(getLanguageCode);
  return <Layout>
      <PageContainerWrapper>
        <PageWidthContainer>
          <PageGrid>
            {!isMobile && <ContentWrapper isMobile={isMobile}>
                <AccountSideMenu anonymousId={anonymousId} brand={brand} />
              </ContentWrapper>}
            <ContentWrapper isMobile={isMobile}>
              <Switch>
                <PrivateRoute path={ACCOUNT_ROUTE} component={AccountRoute} />

                <PrivateReferralRoute path={REFERRAL_ROUTE} component={ReferralRoute} />
                <Route exact path={MEMBERSHIP_ROUTE} component={MembershipRoute} />
                <Route path={ALERTS_ROUTE} component={AlertsRoute} />
              </Switch>
            </ContentWrapper>
          </PageGrid>
        </PageWidthContainer>
      </PageContainerWrapper>

      {!isMobile && <Footer brand={brand} CookiePreferencesLinkSlot={<CookiePreferencesLink brand={brand} />} languageCode={languageCode} />}
    </Layout>;
};
export default UserView;

require("./index.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./index.tsx");